import { axiosInstanceFast } from "./axiosInstance";

export const sourceList = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get("/rdd/api/v1/sources/get-list", {
    signal,
  });
  return response.data.data;
};

export const dataGrowthOverTime = async (
  period?: string,
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/data/source-growth";
  const response = await axiosInstanceFast.post(
    url,
    { period: period ? period : "last_30_days" },
    { signal },
  );
  return response.data.data;
};

export const fileSizeCategory = async (
  data: {
    small_size: number;
    medium_size: number;
    large_size: number;
  } = {
    small_size: 500,
    medium_size: 1000,
    large_size: 1000000,
  },
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/files/size-category";
  const response = await axiosInstanceFast.post(url, data, { signal });
  return response.data.data;
};

export const sensitiveDataSummary = async (
  data: { source: string },
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/data/sensitive-summary";
  const response = await axiosInstanceFast.post(url, data, { signal });
  return response.data.data;
};

export const getSourceDetails = async (
  data: { source: string; source_type: string; is_sensitive?: string },
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/sources/details-summary";
  const response = await axiosInstanceFast.post(url, data, { signal });
  return response.data.data;
};

export const getUserListBySource = async (
  data: { source: string },
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/sources/user-list";
  const response = await axiosInstanceFast.post(url, data, { signal });
  return response.data.data;
};

export const getFileList = async (
  data: {
    source: string;
    silo_name?: string;
    limit?: number;
    page?: number;
    user_name?: string;
    sensitivity?: string;
    domain?: string;
    is_sensitive?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    is_external?: number;
    plugin_id?: string;
    extension?: string;
    cursor?: string;
  },
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/files/get-list";
  const response = await axiosInstanceFast.post(url, data, { signal });
  return response.data;
};

export const dataSubClassification = async (
  data: {
    req_type: string;
    classification: string;
  },
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/data/sub-classification";
  const response = await axiosInstanceFast.post(url, data, { signal });
  return response.data.data;
};

export const getEmailList = async (
  data: {
    source: string;
    email_address?: string;
    limit?: number;
    page?: number;
    sensitivity?: string;
    domain?: string;
    is_sensitive?: string;
    is_external?: number;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    plugin_id?: string;
    extension?: string;
  },
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/emails/get-list";
  const response = await axiosInstanceFast.post(url, data, { signal });
  return response.data;
};

export const getOverdueRetentionFiles = async (signal?: AbortSignal) => {
  const url = "rdd/api/v1/sources/retention-expired";
  const response = await axiosInstanceFast.post(url, {}, { signal });
  return response.data.data;
};

export const getDuplicateFiles = async (
  signal?: AbortSignal,
  data: {
    limit?: number;
    page?: number;
    file_id?: number;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    source?: string;
  } = {},
) => {
  const url = "rdd/api/v1/data/duplicate-files";
  const response = await axiosInstanceFast.post(url, data, { signal });
  return response.data;
};

export const getProgressRatio = async (
  data: {
    type?: string;
    source?: string;
    file_size?: boolean;
    external?: boolean;
    category?: string;
  } = {
    type: "",
    source: "",
    file_size: true,
    external: true,
    category: "",
  },
  signal?: AbortSignal,
) => {
  const url = "rdd/api/v1/files/progress-ratio";

  const response = await axiosInstanceFast.post(url, data, { signal });
  return response.data.data;
};

export const getDataExposureRecord = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get(
    "/rdd/api/v1/files/permission-services-count",
    {
      signal,
    },
  );
  return response.data.data;
};
